import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import BettingGraph from '../BettingGraph';
import s from './Betting.css';

const defaultAlpha = 0.3;

class Betting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alpha: defaultAlpha,
      reset: false,
    };
  }

  handleReset() {
    this.setState({
      alpha: defaultAlpha,
      reset: true,
    });
  }

  handleRankingsClick(evt) {
    this.setState({
      alpha: parseFloat(evt.target.value),
      reset: false,
    });
  }

  renderForm() {
    return (
      <div className={s.form}>
        <div>
          Alpha: &nbsp;
          <input
            type="number"
            name="alpha"
            value={this.state.alpha}
            min="0.0"
            max="0.5"
            step="0.01"
            onChange={(evt) => this.handleRankingsClick(evt)}
          />
          &nbsp;
          <input
            type="submit"
            name="reset"
            value="reset"
            onClick={() => this.handleReset()}
          />
        </div>
      </div>
    );
  }

  renderGraph() {
    return <BettingGraph alpha={this.state.alpha} reset={this.state.reset} />;
  }

  render() {
    return (
      <div>
        {this.renderForm()}
        {this.renderGraph()}
      </div>
    );
  }
}

export default withStyles(s)(Betting);



// WEBPACK FOOTER //
// src/components/Betting/Betting.js